export const FIND_ALL_TEAMS_COMPLETED = "project/teams/findAllTeamsCompleted";
export const FIND_TEAM_BY_ID_COMPLETED = "project/teams/findTeamtByIdCompleted";
export const FIND_TEAM_BY_NAME_COMPLETED = "project/teams/findTeamByNameCompleted";
export const FIND_TEAM_BY_PLAYER_COMPLETED = "project/teams/findTeamByPlayerCompleted";
export const FIND_TEAMS_BY_NAME_COMPLETED = "project/teams/findTeamsByNameCompleted";
export const FIND_TEAMS_BY_ARENA_COMPLETED = "project/teams/findTeamsByArenaCompleted";
export const FIND_TEAMS_BY_OWNER_COMPLETED = "project/teams/findTeamsByOwnerCompleted";
export const UPDATE_TEAM_COMPLETED = "project/teams/updateTeamCompleted";
export const ADD_TEAM_COMPLETED = "project/teams/addTeamCompleted";
export const REMOVE_TEAM_COMPLETED = "project/teams/removeTeamCompleted";
export const ADD_TEAM_TO_SEASON_COMPLETED = "project/teams/addTeamToSeasonCompleted";
export const FIND_TEAMS_TO_SEASON_COMPLETED = "project/teams/findTeamsToSeasonCompleted";
export const REMOVE_TEAM_TO_SEASON_COMPLETED = "project/teams/removeTeamToSeasonCompleted";

